let files = require.context('./component', false, /\.vue$/)
let modules = {}
files.keys().forEach(key => {
  const moduleName = key.replace(/(\.\/|\.vue)/g, '')
  modules[moduleName] = files(key).default
})
export default modules
